import BaseGrid from './Grid';

// EXPORT
export const Grid = BaseGrid;
export type { GridProps } from './Grid.interface';
